import { useQuery } from '@tanstack/react-query';
import { materialsApi } from '@/services/materials';

export const MATERIALS_QUERY_KEY = ['materials'] as const;

export const useMaterials = () => {
  return useQuery({
    queryKey: MATERIALS_QUERY_KEY,
    queryFn: () => materialsApi.list(),
    staleTime: 1000 * 60,       // 1 min (admin stock changes surface within a minute)
    refetchOnMount: 'always',   // always check freshness when the component mounts
  });
};
